const configuredUrl = (process.env.REACT_APP_ADMIN_URL || (process.env.NODE_ENV === 'production' ? '' : 'http://localhost:3001')).trim();

const portalUrl = () => {
  try {
    const url = new URL(configuredUrl);
    return ['http:', 'https:'].includes(url.protocol) && !url.username && !url.password && !url.search && !url.hash ? url.href.replace(/\/$/, '') : '';
  } catch { return ''; }
};

export const ADMIN_PORTAL_URL = portalUrl();
